import React from "react";

import {
  IPackage,
  ISurveyAnswers,
  IDetailsSurvey,
  IStudent,
} from "../../../state";
import RadarChart from "../../../atoms/RadarChart";
import { keyGenerator } from "../../../libs/Util";

import Select from "./components";
import styles from "./ClassDataSurvey.module.scss";

export type Props = {
  packages: IPackage[];
  details_survey: IDetailsSurvey[] | null;
  survey_answers: ISurveyAnswers[];
  survey_answers_per_teaching_material: ISurveyAnswers[];
  student: IStudent;
  nameClass: string;
  fetchSurveyFunc: (material_id: number) => void;
  fetchDetailsSurveyFunc: (package_id: number) => void;
};

interface IQuestion {
  content: string;
  first_answer: number;
  last_answer: number;
}

const ClassDataSurvey: React.FC<Props> = ({
  packages,
  details_survey,
  survey_answers,
  survey_answers_per_teaching_material,
  fetchSurveyFunc,
  fetchDetailsSurveyFunc,
}) => {
  const checkScore = (question: IQuestion, score: number) => {
    if (question.first_answer === score && question.last_answer === score)
      return styles.score__same;
    else if (question.first_answer === score) return styles.score__gray;
    else if (question.last_answer === score) return styles.score__blue;
  };

  return (
    <div className={styles.wrapper}>
      <Select
        packages={packages}
        onChange={(material_id, package_id) => {
          fetchSurveyFunc(material_id);
          fetchDetailsSurveyFunc(package_id);
        }}
      />
      <RadarChart
        survey_answers={survey_answers}
        survey_answers_per_teaching_material={
          survey_answers_per_teaching_material
        }
        className={styles.chart}
        isTeacher
      />
      <div className={styles.note}>
        <h5>事前事後アンケート回答結果</h5>
        <div>
          <p>授業前アンケート結果</p>
          <p>授業後アンケート結果</p>
        </div>
      </div>
      {details_survey &&
        details_survey.map(item =>
          item.survey_topics.map(topic => (
            <div className={styles.result_survey} key={item.id + topic.name}>
              <div className={styles.topic}>
                <div className={styles.name}>
                  <strong>- {topic.name} -</strong>
                </div>
                <div className={styles.score}>
                  <span>1</span>
                  <span>1.5</span>
                  <span>2</span>
                  <span>2.5</span>
                  <span>3</span>
                  <span>3.5</span>
                  <span>4</span>
                  <span>4.5</span>
                  <span>5</span>
                </div>
              </div>
              {topic.questions.map(question => (
                <div className={styles.question} key={keyGenerator(question)}>
                  <div className={styles.name}>{question.content}</div>
                  <div className={styles.score}>
                    <span className={checkScore(question, 1)} />
                    <span className={checkScore(question, 1.5)} />
                    <span className={checkScore(question, 2)} />
                    <span className={checkScore(question, 2.5)} />
                    <span className={checkScore(question, 3)} />
                    <span className={checkScore(question, 3.5)} />
                    <span className={checkScore(question, 4)} />
                    <span className={checkScore(question, 4.5)} />
                    <span className={checkScore(question, 5)} />
                  </div>
                </div>
              ))}
            </div>
          )),
        )}
    </div>
  );
};

export default ClassDataSurvey;
